import {all} from "redux-saga/effects";

import ProductSearchSaga from "./ProductSearchSaga"
import ProductSearchPageSaga from "./ProductSearchPageSaga"
import ProgramMetadataQuerySaga from "./ProgramMetadataQuerySaga"
import ProgramFeesQuerySaga from "./ProgramFeesQuerySaga"
import WeblabSaga from "./WeblabSaga";
import NewProgramFeesQuerySaga from "./NewProgramFeesQuerySaga";
import CurrentCountryCodeQuerySaga from "./CurrentCountryCodeQuerySaga";
import SelectedProductSaga from "./SelectedProductSaga";
import QueryProductSaga from "./QueryProductSaga";
import RecommendationQuerySaga from "./RecommendationQuerySaga";
import UserPreferenceQuery from "src/sagas/UserPreferenceQuerySaga";
import UserPreferenceUpdate from "src/sagas/UserPreferenceUpdateSaga";
import BulkProductSearchSaga from "src/sagas/BulkProductSearchSaga";
import BulkReportQuerySaga from "src/sagas/BulkReportQuerySaga";
import FeeCatQuerySaga from "./FeeCatQuerySaga";


function createSagaArray() {
    let sagaArray = [
        ProductSearchSaga(),
        ProductSearchPageSaga(),
        SelectedProductSaga(),
        QueryProductSaga(),
        ProgramMetadataQuerySaga(),
        RecommendationQuerySaga(),
        ProgramFeesQuerySaga(),
        NewProgramFeesQuerySaga(),
        WeblabSaga(),
        CurrentCountryCodeQuerySaga(),
        UserPreferenceQuery(),
        UserPreferenceUpdate(),
        BulkProductSearchSaga(),
        BulkReportQuerySaga(),
        FeeCatQuerySaga(),
    ];

    return sagaArray;
}

export default function* combinedSaga() {
    // @ts-ignore
    let sagaArray = yield createSagaArray();

    yield all(
        sagaArray
    );
}